import React from "react"
import { fetchActiveBlogs, APIpath } from '../actions'
import { getPosts } from '../reducers'
import { connect } from 'react-redux'
import { Image, Text, Flex, Box, Button, Heading, SimpleGrid } from '@chakra-ui/react'
import Layout from '../layout'
import vehiculo from '../multimedia/imagenes/vehiculo3.png'
import { Link } from "react-router-dom"


class BlogLanding extends React.Component {

    componentDidMount() {
        this.props.fetchActiveBlogs()
    }

    render() {

        const { posts } = this.props

        return (
            <Layout>
                <Flex flexDir={{ base: 'column', md: 'row' }} bg={"easycar1.500"} w={"100%"} p={5} textAlign={"center"} marginTop={"20px"} marginBottom={"20px"} alignItems={"center"} display={"flex"} justifyContent={"space-evenly"}>
                    <Text as={"b"} fontSize={"4xl"} color={"white"}>Estrena tu próximo vehículo mediante pagos mensuales en 24 horas</Text> <a
                        href={`https://wa.me/+50372900087?text=Hola%2C+me+gustaria+precalificar+para+adquirir+un+veh%C3%ADculo+de+su+sitio+web+en+pagos+mensuales.&type=phone_number&app_absent=0`}
                        target={"_blank"}
                        rel="noreferrer">
                        <Button colorScheme={"green"}>
                            Chatea con un ejecutivo/a
                        </Button>
                    </a>
                </Flex>

                <Box w={"full"} >
                    <Flex maxW={"1400px"} flexDir={'column'} p={4} m={"auto"} mt={"3rem"}>

                        <Flex
                            direction={{ base: 'column', md: 'row' }}
                            alignItems={{ base: 'flex-start', md: 'flex-end' }}
                            justifyContent="space-between"
                            mb={10}
                            gap={6}
                            borderBottom="1px solid"
                            borderColor="gray.200"
                            pb={6}
                        >
                            <Box>
                                <Flex alignItems="center" gap={2} mb={2}>
                                    <Box
                                        as="span"
                                        bg="green.100"
                                        color="green.800"
                                        fontSize="xs"
                                        fontWeight="extrabold"
                                        px={3}
                                        py={1}
                                        borderRadius="full"
                                        textTransform="uppercase"
                                        letterSpacing="widest"
                                    >
                                        Centro de Conocimiento
                                    </Box>
                                </Flex>
                                <Heading
                                    as="h1"
                                    fontSize={{ base: '3xl', sm: '5xl' }}
                                    fontWeight="extrabold"
                                    color="gray.900"
                                    letterSpacing="tight"
                                >
                                    EASYCAR BLOG
                                </Heading>
                                <Text color="gray.500" fontSize="base" mt={2} maxW="xl">
                                    Consejos expertos de automoción, mantenimiento preventivo y arrendamiento vehicular en El Salvador.
                                </Text>
                            </Box>
                        </Flex>

                        <br />
                        <Flex flexDir={{ base: 'column', md: 'row' }} gap={3}>

                            <Box width={{ base: 'full', md: "100%" }}>
                                {
                                    posts.length > 0 ?
                                        <Link to={`/blog/${posts[0].id}?${Math.random().toString(36)}`} style={{ textDecoration: 'none' }}>
                                            <Box
                                                bg="white"
                                                border="1px solid"
                                                borderColor="gray.200"
                                                borderRadius="3xl"
                                                p={{ base: 6, sm: 8 }}
                                                boxShadow="sm"
                                                transition="all 0.3s"
                                                _hover={{ boxShadow: 'xl' }}
                                                role="group"
                                                cursor="pointer"
                                            >
                                                <Box>
                                                    <Box position="relative" mb={6} overflow="hidden" borderRadius="2xl" bg="gray.100">
                                                        <Image
                                                            alt={posts[0].title}
                                                            height={{ base: '14rem', sm: '18rem' }}
                                                            width="full"
                                                            src={`${APIpath}/blog/image/${posts[0].id}`}
                                                            objectFit="cover"
                                                        />
                                                        <Text
                                                            position="absolute"
                                                            bottom={4}
                                                            left={4}
                                                            bg="whiteAlpha.900"
                                                            color="green.800"
                                                            fontSize="xs"
                                                            fontWeight="extrabold"
                                                            px={3.5}
                                                            py={1.5}
                                                            borderRadius="xl"
                                                            textTransform="uppercase"
                                                            letterSpacing="wider"
                                                            boxShadow="md"
                                                        >
                                                            Destacado
                                                        </Text>
                                                    </Box>
                                                    {
                                                        posts[0].tag.includes(',') ? posts[0].tag.split(',').map((tag, index) =>
                                                            <Text key={index} display="inline-block" bg="green.100" color="green.800" fontSize="11px" fontWeight="extrabold" px={3.5} py={1} borderRadius="full" textTransform="uppercase" mr={2}>
                                                                {tag.trim()}
                                                            </Text>
                                                        ) :
                                                            <Text display="inline-block" bg="green.100" color="green.800" fontSize="11px" fontWeight="extrabold" px={3.5} py={1} borderRadius="full" textTransform="uppercase">
                                                                {posts[0].tag}
                                                            </Text>
                                                    }
                                                    <Heading
                                                        as="h2"
                                                        fontSize={{ base: 'xl', sm: '2xl' }}
                                                        fontWeight="extrabold"
                                                        color="gray.900"
                                                        mt={3}
                                                        mb={3}
                                                        lineHeight="tight"
                                                        transition="color 0.2s"
                                                        _groupHover={{ color: 'green.600' }}
                                                    >
                                                        {posts[0].title}
                                                    </Heading>
                                                     <Text
                                                            fontSize="xs"
                                                            fontWeight="semibold"
                                                            color="gray.400"
                                                            mb={6}
                                                            pb={4}
                                                            borderBottom="1px solid"
                                                            borderColor="gray.100"
                                                        >
                                                            Publicado: { new Date(posts[0].updated_at).toLocaleDateString() }
                                                        </Text>
                                                    <Text noOfLines={2} color="gray.600" fontSize={{ base: 'sm', sm: 'md' }} lineHeight="relaxed">
                                                        {posts[0].description}
                                                    </Text>
                                                </Box>
                                                <Flex
                                                    mt={6}
                                                    pt={4}
                                                    borderTop="1px solid"
                                                    borderColor="gray.100"
                                                    justifyContent="flex-end"
                                                    alignItems="center"
                                                    color="green.600"
                                                    fontSize="xs"
                                                    fontWeight="semibold"
                                                    gap={2}
                                                >
                                                    <Text>Leer artículo completo</Text>
                                                    <Text transition="transform 0.2s" _groupHover={{ transform: 'translateX(4px)' }}>→</Text>
                                                </Flex>
                                            </Box>
                                        </Link>
                                        : "No se encuentran entradas"
                                }
                            </Box>

                            <Flex
                                position="relative"
                                overflow="hidden"
                                flexDir="column"
                                alignItems="center"
                                justifyContent="space-between"
                                gap={3}
                                bgGradient="linear(to-br, green.600, teal.700)"
                                borderRadius="3xl"
                                boxShadow="0 20px 35px -15px rgba(5, 150, 105, 0.4)"
                                color="white"
                                textAlign="center"
                                width={{ base: 'full', md: "400px" }}
                                p={8}
                            >
                                <Box
                                    position="absolute"
                                    inset={0}
                                    opacity={0.1}
                                    pointerEvents="none"
                                    backgroundImage="radial-gradient(#fff 1px, transparent 1px)"
                                    backgroundSize="16px 16px"
                                />
                                <Box position="relative" zIndex={1} width="full" pt={2}>
                                    <Heading as="h3" fontSize="2xl" fontWeight="extrabold" letterSpacing="tight" mt={4} mb={3}>
                                        Encuentra el carro ideal para ti
                                    </Heading>
                                    <Text color="green.100" fontSize="sm" mb={6} lineHeight="relaxed">
                                        Inspeccionados, con garantía y listos para estrenar en menos de 24 horas.
                                    </Text>
                                    <Flex
                                        my={2}
                                        height="9rem"
                                        borderRadius="2xl"
                                        bg="whiteAlpha.200"
                                        p={2.5}
                                        border="1px solid"
                                        borderColor="whiteAlpha.400"
                                        boxShadow="inner"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Image alt="Catálogo de vehículos Easycar" height="full" maxWidth="full" src={vehiculo} objectFit="contain" />
                                    </Flex>
                                </Box>
                                <Box position="relative" zIndex={1} width="full" mt={6}>
                                    <Link to="/cars" style={{ display: 'block', width: '100%' }}>
                                        <Button
                                            width="full"
                                            bg="white"
                                            color="gray.900"
                                            py={6}
                                            borderRadius="2xl"
                                            fontWeight="extrabold"
                                            boxShadow="lg"
                                            transition="all 0.2s"
                                            _hover={{ bg: 'gray.100', transform: 'translateY(-2px)' }}
                                        >
                                            Catalogo de vehículos
                                        </Button>
                                    </Link>
                                </Box>
                            </Flex>
                        </Flex>

                        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={"10"} p={"16px"} width={'full'}>
                            {
                                posts.map((post, index) => {
                                    if (index === 0) return ""
                                    else {
                                        return (
                                            <Box
                                                width={{ base: 'full', md: "100%" }}
                                                bg="white"
                                                border="1px solid"
                                                borderColor="gray.200"
                                                borderRadius="3xl"
                                                overflow="hidden"
                                                boxShadow="sm"
                                                transition="all 0.2s ease"
                                                _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)' }}
                                                key={post.id || index}
                                            >
                                                <Link to={`/blog/${post.id}?${Math.random().toString(36)}`} style={{ textDecoration: 'none' }}>
                                                    <Box p={{ base: 5, sm: 6 }}>
                                                        {
                                                        post.tag.includes(',') ? post.tag.split(',').map((tag, index) =>
                                                            <Text key={index} display="inline-block" bg="green.100" color="green.800" fontSize="11px" fontWeight="extrabold" px={3.5} py={1} borderRadius="full" textTransform="uppercase" mr={2}>
                                                                {tag.trim()}
                                                            </Text>
                                                        ) :
                                                            <Text display="inline-block" bg="green.100" color="green.800" fontSize="11px" fontWeight="extrabold" px={3.5} py={1} borderRadius="full" textTransform="uppercase">
                                                                {post.tag}
                                                            </Text>
                                                    }

                                                        <Heading
                                                            as="h3"
                                                            fontSize={{ base: 'xl', sm: '2xl' }}
                                                            fontWeight="extrabold"
                                                            color="gray.900"
                                                            mt={4}
                                                            mb={4}
                                                            lineHeight="tight"
                                                        >
                                                            {post.title}
                                                        </Heading>

                                                        <Text
                                                            fontSize="xs"
                                                            fontWeight="semibold"
                                                            color="gray.400"
                                                            mb={6}
                                                            pb={4}
                                                            borderBottom="1px solid"
                                                            borderColor="gray.100"
                                                        >
                                                            Publicado: { new Date(post.updated_at).toLocaleDateString() }
                                                        </Text>

                                                        <Box
                                                            width="full"
                                                            height={{ base: '220px', md: '240px' }}
                                                            bg="gray.100"
                                                            borderRadius="2xl"
                                                            overflow="hidden"
                                                            mb={6}
                                                            border="1px solid"
                                                            borderColor="gray.200"
                                                        >
                                                            <Image
                                                                alt={post.title}
                                                                height="100%"
                                                                width="full"
                                                                src={`${APIpath}/blog/image/${post.id}`}
                                                                objectFit="cover"
                                                            />
                                                        </Box>

                                                        <Box color="gray.700" lineHeight="relaxed" fontSize={{ base: 'sm', sm: 'md' }}>
                                                            <Text noOfLines={4}>{post.description}</Text>
                                                        </Box>

                                                        <Flex
                                                            mt={6}
                                                            pt={4}
                                                            borderTop="1px solid"
                                                            borderColor="gray.100"
                                                            justifyContent="flex-end"
                                                            alignItems="center"
                                                            color="green.600"
                                                            fontSize="xs"
                                                            fontWeight="semibold"
                                                            gap={2}
                                                        >
                                                            <Text>Leer artículo completo</Text>
                                                            <Text>→</Text>
                                                        </Flex>
                                                    </Box>
                                                </Link>
                                            </Box>
                                        )
                                    }
                                })
                            }
                        </SimpleGrid>
                    </Flex>

                </Box>
            </Layout>
        )

    }

}

const mapStateToProps = (state) => ({
    posts: getPosts(state),
})

const mapDispatchToProps = { fetchActiveBlogs }

export default connect(mapStateToProps, mapDispatchToProps)(BlogLanding)